import axios from 'axios'

import {API_URL} from './endpoints'

export const $api = axios.create({
  url: API_URL,
})
